// Shared list of commonly used countries (extend as needed)
// Each entry: iso (lowercase), name (readable), dial (international prefix with +)
export interface CountryDial {
  iso: string;
  name: string;
  dial: string;
}

export const COUNTRIES: CountryDial[] = [
  { iso: 'de', name: 'Germany', dial: '+49' },
  { iso: 'at', name: 'Austria', dial: '+43' },
  { iso: 'af', name: 'Afghanistan', dial: '+93' },
  { iso: 'al', name: 'Albania', dial: '+355' },
  { iso: 'dz', name: 'Algeria', dial: '+213' },
  { iso: 'ar', name: 'Argentina', dial: '+54' },
  { iso: 'au', name: 'Australia', dial: '+61' },
  { iso: 'bh', name: 'Bahrain', dial: '+973' },
  { iso: 'bd', name: 'Bangladesh', dial: '+880' },
  { iso: 'by', name: 'Belarus', dial: '+375' },
  { iso: 'be', name: 'Belgium', dial: '+32' },
  { iso: 'bt', name: 'Bhutan', dial: '+975' },
  { iso: 'bo', name: 'Bolivia', dial: '+591' },
  { iso: 'ba', name: 'Bosnia and Herzegovina', dial: '+387' },
  { iso: 'br', name: 'Brazil', dial: '+55' },
  { iso: 'bg', name: 'Bulgaria', dial: '+359' },
  { iso: 'kh', name: 'Cambodia', dial: '+855' },
  { iso: 'ca', name: 'Canada', dial: '+1' },
  { iso: 'cl', name: 'Chile', dial: '+56' },
  { iso: 'cn', name: 'China', dial: '+86' },
  { iso: 'co', name: 'Colombia', dial: '+57' },
  { iso: 'cy', name: 'Cyprus', dial: '+357' },
  { iso: 'cz', name: 'Czech Republic', dial: '+420' },
  { iso: 'dk', name: 'Denmark', dial: '+45' },
  { iso: 'ec', name: 'Ecuador', dial: '+593' },
  { iso: 'eg', name: 'Egypt', dial: '+20' },
  { iso: 'ee', name: 'Estonia', dial: '+372' },
  { iso: 'sz', name: 'Eswatini', dial: '+268' },
  { iso: 'et', name: 'Ethiopia', dial: '+251' },
  { iso: 'fi', name: 'Finland', dial: '+358' },
  { iso: 'fr', name: 'France', dial: '+33' },
  { iso: 'gr', name: 'Greece', dial: '+30' },
  { iso: 'hu', name: 'Hungary', dial: '+36' },
  { iso: 'is', name: 'Iceland', dial: '+354' },
  { iso: 'in', name: 'India', dial: '+91' },
  { iso: 'id', name: 'Indonesia', dial: '+62' },
  { iso: 'ir', name: 'Iran', dial: '+98' },
  { iso: 'iq', name: 'Iraq', dial: '+964' },
  { iso: 'ie', name: 'Ireland', dial: '+353' },
  { iso: 'il', name: 'Israel', dial: '+972' },
  { iso: 'it', name: 'Italy', dial: '+39' },
  { iso: 'jp', name: 'Japan', dial: '+81' },
  { iso: 'jo', name: 'Jordan', dial: '+962' },
  { iso: 'kz', name: 'Kazakhstan', dial: '+7' },
  { iso: 'ke', name: 'Kenya', dial: '+254' },
  { iso: 'kw', name: 'Kuwait', dial: '+965' },
  { iso: 'kg', name: 'Kyrgyzstan', dial: '+996' },
  { iso: 'la', name: 'Laos', dial: '+856' },
  { iso: 'lv', name: 'Latvia', dial: '+371' },
  { iso: 'lb', name: 'Lebanon', dial: '+961' },
  { iso: 'ls', name: 'Lesotho', dial: '+266' },
  { iso: 'ly', name: 'Libya', dial: '+218' },
  { iso: 'lt', name: 'Lithuania', dial: '+370' },
  { iso: 'lu', name: 'Luxembourg', dial: '+352' },
  { iso: 'mg', name: 'Madagascar', dial: '+261' },
  { iso: 'my', name: 'Malaysia', dial: '+60' },
  { iso: 'mv', name: 'Maldives', dial: '+960' },
  { iso: 'mt', name: 'Malta', dial: '+356' },
  { iso: 'mu', name: 'Mauritius', dial: '+230' },
  { iso: 'mx', name: 'Mexico', dial: '+52' },
  { iso: 'md', name: 'Moldova', dial: '+373' },
  { iso: 'mn', name: 'Mongolia', dial: '+976' },
  { iso: 'me', name: 'Montenegro', dial: '+382' },
  { iso: 'ma', name: 'Morocco', dial: '+212' },
  { iso: 'mm', name: 'Myanmar', dial: '+95' },
  { iso: 'na', name: 'Namibia', dial: '+264' },
  { iso: 'np', name: 'Nepal', dial: '+977' },
  { iso: 'nl', name: 'Netherlands', dial: '+31' },
  { iso: 'nz', name: 'New Zealand', dial: '+64' },
  { iso: 'ng', name: 'Nigeria', dial: '+234' },
  { iso: 'no', name: 'Norway', dial: '+47' },
  { iso: 'om', name: 'Oman', dial: '+968' },
  { iso: 'pk', name: 'Pakistan', dial: '+92' },
  { iso: 'py', name: 'Paraguay', dial: '+595' },
  { iso: 'ph', name: 'Philippines', dial: '+63' },
  { iso: 'pl', name: 'Poland', dial: '+48' },
  { iso: 'pt', name: 'Portugal', dial: '+351' },
  { iso: 'qa', name: 'Qatar', dial: '+974' },
  { iso: 'ro', name: 'Romania', dial: '+40' },
  { iso: 'ru', name: 'Russia', dial: '+7' },
  { iso: 'rw', name: 'Rwanda', dial: '+250' },
  { iso: 'sa', name: 'Saudi Arabia', dial: '+966' },
  { iso: 'sc', name: 'Seychelles', dial: '+248' },
  { iso: 'sg', name: 'Singapore', dial: '+65' },
  { iso: 'sk', name: 'Slovakia', dial: '+421' },
  { iso: 'si', name: 'Slovenia', dial: '+386' },
  { iso: 'za', name: 'South Africa', dial: '+27' },
  { iso: 'kr', name: 'South Korea', dial: '+82' },
  { iso: 'es', name: 'Spain', dial: '+34' },
  { iso: 'lk', name: 'Sri Lanka', dial: '+94' },
  { iso: 'sd', name: 'Sudan', dial: '+249' },
  { iso: 'se', name: 'Sweden', dial: '+46' },
  { iso: 'ch', name: 'Switzerland', dial: '+41' },
  { iso: 'sy', name: 'Syria', dial: '+963' },
  { iso: 'tj', name: 'Tajikistan', dial: '+992' },
  { iso: 'th', name: 'Thailand', dial: '+66' },
  { iso: 'tn', name: 'Tunisia', dial: '+216' },
  { iso: 'tr', name: 'Turkey', dial: '+90' },
  { iso: 'tm', name: 'Turkmenistan', dial: '+993' },
  { iso: 'ua', name: 'Ukraine', dial: '+380' },
  { iso: 'ae', name: 'United Arab Emirates', dial: '+971' },
  { iso: 'gb', name: 'United Kingdom', dial: '+44' },
  { iso: 'us', name: 'United States', dial: '+1' },
  { iso: 'uy', name: 'Uruguay', dial: '+598' },
  { iso: 'uz', name: 'Uzbekistan', dial: '+998' },
  { iso: 've', name: 'Venezuela', dial: '+58' },
  { iso: 'vn', name: 'Vietnam', dial: '+84' },
  { iso: 'ye', name: 'Yemen', dial: '+967' },
  { iso: 'zm', name: 'Zambia', dial: '+260' },
  { iso: 'zw', name: 'Zimbabwe', dial: '+263' },
];

export function findCountryByDial(dial: string): CountryDial | undefined {
  return COUNTRIES.find((c) => c.dial === dial);
}

export function findCountryByIso(iso: string): CountryDial | undefined {
  return COUNTRIES.find((c) => c.iso === iso.toLowerCase());
}
